// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Currency from "../../../../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Belt_Option from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as ErrorUtils$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as ModificationPreview from "../modification-preview/ModificationPreview.bs.js";
import * as CreateModificationUtils from "../../../../library/utils/CreateModificationUtils.bs.js";
import * as SimpleModificationState from "./SimpleModificationState.bs.js";
import * as CurrencyMajorMinorMapper from "../../../../../../../../../library/data-source/country-currency/CurrencyMajorMinorMapper.bs.js";
import * as ProgressStepper$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/stepper/progress-stepper/ProgressStepper.bs.js";
import * as SimpleEligibilityRulesForm from "./SimpleEligibilityRulesForm.bs.js";
import * as ProgressStepperHook$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/stepper/progress-stepper/ProgressStepperHook.bs.js";
import * as SimpleModificationStepperConfig from "./SimpleModificationStepperConfig.bs.js";
import * as SimpleModificationKeyDetailsForm from "./SimpleModificationKeyDetailsForm.bs.js";
import * as SimpleModificationBaseDetailsForm from "./SimpleModificationBaseDetailsForm.bs.js";
import * as SimpleModificationSlabDetailsForm from "./SimpleModificationSlabDetailsForm.bs.js";

function resolveOption(data) {
  if (data !== undefined) {
    return Caml_option.valFromOption(data);
  } else {
    return Curry._1(ErrorUtils$Catalyst.raiseError("SimpleModificationForm.re", "Data incomplete to show preview", undefined), undefined);
  }
}

function SimpleModificationForm(Props) {
  var core_pricing = Props.core_pricing;
  var close_modal = Props.close_modal;
  var openConfirmationModal = Props.openConfirmationModal;
  var match = React.useState(function () {
        return SimpleModificationState.initial_state;
      });
  var updateState = match[1];
  var state = match[0];
  var match$1 = ProgressStepperHook$Catalyst.useStepper(SimpleModificationStepperConfig.steppers, /* KeyDetails */0, ProgressStepper$Catalyst.Classes.make(" create-modification-stepper-root", undefined, undefined, undefined, undefined, undefined, undefined, undefined), undefined);
  var resetStepper = match$1.resetStepper;
  var setCompleted = match$1.setCompleted;
  var setActive = match$1.setActive;
  var tmp;
  switch (match$1.active) {
    case /* KeyDetails */0 :
        tmp = React.createElement(SimpleModificationKeyDetailsForm.make, {
              key_details: state.key_details,
              core_pricing_start_date: core_pricing.start_date,
              modification_type: /* Simple */1,
              onNext: (function (details) {
                  Curry._1(updateState, (function (pre) {
                          return {
                                  key_details: details,
                                  base_details: pre.base_details,
                                  slab_details: pre.slab_details,
                                  eligiblity_rules: pre.eligiblity_rules
                                };
                        }));
                  Curry._1(setActive, /* BaseDetails */1);
                  return Curry._1(setCompleted, /* KeyDetails */0);
                }),
              onBack: (function (param) {
                  return Curry._1(openConfirmationModal, undefined);
                })
            });
        break;
    case /* BaseDetails */1 :
        tmp = React.createElement(SimpleModificationBaseDetailsForm.make, {
              base_details: state.base_details,
              core_pricing: core_pricing,
              onNext: (function (details) {
                  Curry._1(updateState, (function (pre) {
                          return {
                                  key_details: pre.key_details,
                                  base_details: details,
                                  slab_details: pre.slab_details,
                                  eligiblity_rules: pre.eligiblity_rules
                                };
                        }));
                  Curry._1(setActive, /* SlabDetails */2);
                  return Curry._1(setCompleted, /* BaseDetails */1);
                }),
              onBack: (function (param) {
                  Curry._1(setActive, /* KeyDetails */0);
                  return Curry._1(resetStepper, /* BaseDetails */1);
                })
            });
        break;
    case /* SlabDetails */2 :
        tmp = React.createElement(SimpleModificationSlabDetailsForm.make, {
              active_slabs: CreateModificationUtils.toCorPricingSlab(core_pricing.slabs),
              submitted_slabs: state.slab_details,
              onNext: (function (slabs) {
                  Curry._1(updateState, (function (pre) {
                          return {
                                  key_details: pre.key_details,
                                  base_details: pre.base_details,
                                  slab_details: slabs,
                                  eligiblity_rules: pre.eligiblity_rules
                                };
                        }));
                  Curry._1(setActive, /* EligibilityRules */3);
                  return Curry._1(setCompleted, /* SlabDetails */2);
                }),
              onBack: (function (param) {
                  Curry._1(setActive, /* BaseDetails */1);
                  return Curry._1(resetStepper, /* SlabDetails */2);
                }),
              free_slab_params: {
                free_kms: Belt_Option.mapWithDefault(state.base_details, core_pricing.free_kms, (function (d) {
                        return d.free_kms_delta + core_pricing.free_kms | 0;
                      })),
                price_per_min: CurrencyMajorMinorMapper.currencyToBase(Belt_Option.mapWithDefault(state.base_details, core_pricing.free_km_price_per_min, (function (d) {
                            return Currency.add(d.free_km_price_delta, core_pricing.free_km_price_per_min);
                          })))
              }
            });
        break;
    case /* EligibilityRules */3 :
        tmp = React.createElement(SimpleEligibilityRulesForm.make, {
              eligiblity_rules: state.eligiblity_rules,
              onNext: (function (eligiblity_rules) {
                  Curry._1(updateState, (function (pre) {
                          return {
                                  key_details: pre.key_details,
                                  base_details: pre.base_details,
                                  slab_details: pre.slab_details,
                                  eligiblity_rules: eligiblity_rules
                                };
                        }));
                  Curry._1(setActive, /* Preview */4);
                  return Curry._1(setCompleted, /* EligibilityRules */3);
                }),
              onBack: (function (param) {
                  Curry._1(setActive, /* SlabDetails */2);
                  return Curry._1(resetStepper, /* EligibilityRules */3);
                })
            });
        break;
    case /* Preview */4 :
        tmp = React.createElement(ModificationPreview.make, {
              modification_form_data: {
                TAG: /* Simple */1,
                key_details: resolveOption(state.key_details),
                base_details: resolveOption(state.base_details),
                slab_details: resolveOption(state.slab_details),
                eligiblity_rules: resolveOption(state.eligiblity_rules)
              },
              core_pricing: core_pricing,
              close_create_modal: close_modal,
              onBack: (function (param) {
                  Curry._1(setActive, /* EligibilityRules */3);
                  return Curry._1(resetStepper, /* Preview */4);
                })
            });
        break;
    
  }
  return React.createElement(React.Fragment, undefined, match$1.steppers_cmp, tmp);
}

var make = SimpleModificationForm;

export {
  resolveOption ,
  make ,
  
}
/* react Not a pure module */
